/** Any characters, length 8�20 */
export const PASSWORD_REGEX = /^.{8,20}$/;

export const PASSWORD_REQUIREMENTS_MESSAGE =
  "";

export function isValidPassword(password) {
  return PASSWORD_REGEX.test(password);
}
